export default "<div x-data=\"autocomplete\">\n  <input autocomplete=\"off\" type=\"text\"/>\n</div>"